import EventBus from "../components/event-bus";
import {HTTP} from '../http-common';
import moment from 'moment';
import Swal from 'sweetalert2';

export const commonMixins = {

    data: () => ({
            colors: ['#ffbb44', '#098de1', '#154174', '#c3202b', '#607d8b', '#444444', '#446626', '#cc9636', '#23727b'],
            menuData: [
                {

                }
            ],
            features: [
                {

                }
            ],
            menuslug: "",
            pageType: "",
            currentTab: "",
            menuParentSlug: "",
            systemYear: "2019",
            loginUserPermission: [],
            activeMenu: '',
        }),
    mounted: function () {

        var self = this;

        //check token if user came from rental
        var token = this.$route.query.token;
        if (token != undefined) {
            localStorage.setItem("tkn", token);
        }

        /* if Acces Token is not exits redirect to login page. */
        if (localStorage.getItem("tkn") == "" || localStorage.getItem("tkn") == null) {
            localStorage.clear();
            // self.$router.push("/");
        }
        $("html, body").animate({scrollTop: 0}, 10);
    },
    created() {
        /*console.log("mixin created");*/
    },
    beforeMount() {

    },
    watch: {
        menuslug: function (menuslug) {
            var self = this;
            setTimeout(function () {
                self.menuActive(menuslug);
            }, 1000);
            //self.$store.dispatch('getRole');
        }
    },

    methods: {
        /* Get User Role Permission */
        getRole: function () {
            var self = this;
            var config = {
                headers: {Authorization: "Bearer " + localStorage.getItem("tkn")}
            };
            HTTP.post("/user/role", {}, config)
                .then(function (response) {
                    if (response.data.status == 'success') {
                        localStorage.setItem("user_role", response.data.roles.id);
                    }
                })
                .catch(function (err) {                    
                    if (err && err.response && err.response.status == 0) {
                        self.error = "Remote server can not be reachable";
                    } else {
                    //redirect to login page if user not authenticated
                    if (err && err.response && err.response.status == 401) {
                        localStorage.removeItem('user_obj');
                        localStorage.removeItem('api_token');
                        window.location.href = process.env.SSO_ROOT_URL + "/logout?redirect_url=" + process.env.FRONT_ROOT_URL + '&slug=' + process.env.PROJECT_SLUG;
                        // self.$router.push("/");
                    }
                }
            });
        },
        
        //make sentence first letter capital
        ucString: function (data) {
            var self = this;
            var value = data.replace(/_/g, " ");
            var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                return letter.toUpperCase();
            });
            return upp;
        },
        // menuActive: function (slug) {
        //     /* console.log(slug); */
        // //setTimeout(function () {
        //     $(".menuCommon").removeClass("active");
        //     $("." + slug).addClass("active");
        //     $("." + slug).parent().show();
        //     $('#menu ul').children('.current').parent().show();
        //     $('#menu li a').click(
        //         function() {
        //             var checkElement = $(this).next();
        //             if ((checkElement.is('ul')) && (checkElement.is(':visible'))) {
        //                 return false;
        //             }
        //             if ((checkElement.is('ul')) && (!checkElement.is(':visible'))) {
        //                 $('#menu ul:visible').slideUp('normal');
        //                 checkElement.slideDown('normal');
        //                 return false;
        //             }
        //         }
        //     );

        // //}, 1000);
        // },
        changeTab: function (tab) {
            var self = this;
            self.currentTab = tab;
            if (tab == "discussion") {
                $(".btnDiscussion").removeClass("btn-outline-primary");
                $(".btnDiscussion").addClass("btn-primary");
                $(".btnAttachment").removeClass("btn-primary");
                $(".btnAttachment").addClass("btn-outline-primary");
            } else {
                $(".btnAttachment").removeClass("btn-outline-primary");
                $(".btnAttachment").addClass("btn-primary");
                $(".btnDiscussion").removeClass("btn-primary");
                $(".btnDiscussion").addClass("btn-outline-primary");
            }
        },
        utcToLocal: function (dateTime, format) {
            var self = this;
            var local = moment.utc(dateTime).local().format(format);
            return local;
        },
        formatDateTime: function (dateTime, format) {
            var self = this;
            var dateTime = new Date(dateTime);
            var dateTime = moment(dateTime).format(format);
            return dateTime;
        },
        gerRandomColor: function () {
            var self = this;
            var item = self.colors[Math.floor(Math.random() * self.colors.length)];
            return item;
        },
        showSAlert: function (message, type, callback, timer) {
            var obj = {};
            if (message === null || typeof message === "undefined" || message == '') {
            } else {
                obj['html'] = message;
            }
            if (type === null || typeof type === "undefined" || type == '') {
            } else {
                obj['type'] = type;
            }
            if (timer === null || typeof timer === "undefined" || timer == '') {
            } else {
                timer = (timer * 1000);
                obj['timer'] = timer;
                obj['showConfirmButton'] = false;
            }
            Swal.fire(obj).then(callback);
        },
        catchHandler: function (err, callback) {
            var self = this;
            if (err && err.response && err.response.status) {
                switch (err.response.status) {
                    case 0:
                        this.showSAlert('Remote server can not be reachable', 'error', callback);
                    case 400:
                        this.showSAlert(err.response.data.message, 'error', callback);
                        break;
                    case 401:
                        localStorage.removeItem("user_obj");
                        localStorage.removeItem("tkn");
                        // self.$router.push("/");
                        window.location.href = process.env.SSO_ROOT_URL + "/logout?redirect_url=" + process.env.FRONT_ROOT_URL + '&slug=' + process.env.PROJECT_SLUG;
                        break;
                    case 404:
                        this.showSAlert(err.response.data.message, 'error', callback);
                        break;
                    case 409:
                        this.showSAlert(err.response.data.message, 'error', callback);
                        break;
                }
            }
        },
        removeSpacesString: function (srting) {
            return srting.replace(/\s/g, '').toLowerCase();
        },
        stringTrim: function (string, length) {
            length = (typeof length !== 'undefined') ? length : 20;
            var string1 = (string.length > length) ? string.substring(0, length) + '...' : string;
            return string1;
        },
        showLoader: function () {
            $(".loading-container").show();
        },
        hideLoader: function () {
            //setTimeout(function () {
                $(".loading-container").hide();
            //}, 1700);
        },
        firstLoadMenu: function () {
            var self = this;
            $('#menu ul').hide();
        },
        enableDisableButton: function (identifire,is_disable,is_id) {
            if(is_id == true){
                $('#'+identifire).attr("disable", is_disable);
            } else {
                $('.'+identifire).attr("disable", is_disable);
            }
        },
        arrayContainsArray: function (superset, subset) {
            var resp = false;
            $.each(superset, function (i) {
                $.each(subset, function (j) {
                    if(superset[i] == subset[j]){
                        resp = true;
                    }
                });
            });
            /*return subset.every(function (value) {
             return (superset.indexOf(value) >= 0);
             });*/
            return resp;
        },
        checkLogin: function() {
            var self = this;
            /* Redirect to login page logic start */
            var userObj = localStorage.getItem("user_obj");
            if (userObj == null) {
                window.location.href = "/";
                // window.location.href = process.env.SSO_ROOT_URL + "/logout?redirect_url=" + process.env.FRONT_ROOT_URL + '&slug=' + process.env.PROJECT_SLUG;
            }
            /* Redirect to login page logic end */
        },
        loadTag: function() {
            var self = this;
            var oldTag = localStorage.getItem('tag');
            HTTP.get("/pinger", {})
                .then(function (response) {
                    if (response.data.code == '200') {
                        var tag = response.data.content.tag
                        if (!oldTag || oldTag=='' || oldTag==null || oldTag != tag) {
                            localStorage.setItem("tag", response.data.content.tag);
                            window.location.reload(true);
                        }
                    }
                })
                .catch(function (err) {
                    self.catchHandler(err, function () { });
                });
        },
        websiteUrlValidation : function(url) {
            if(url != '' && url != null){
                var res = url.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g);
                if(res == null) {
                    return false;
                } else {
                    return true;
                }
            }
            return false;
        },
        validContactNumber: function (number) {
            return /^[0-9 -()+,-]*$/.test(number);
        },
        checkContactNoLength: function (val) {
            if (val.length > 13) {
                return false;
            } else {
                return true;
            }
        },
        replaceDashesWithSpaces(str) {
            return str.replace(/-/g, ' ');
        },
        getActiveMenu: function () {
            return self.activeMenu;
        },
        setActiveMenu: function (menu) {
            self.activeMenu = menu;
        },
        breakLongString: function(column, maxLength) {
            if(column != null && column != "") {
                let result = '';
                for (let i = 0; i < column.length; i += maxLength) {
                    result += column.substring(i, i + maxLength) + '<br>'; // Add new line
                }
                return result.trim(); // Remove trailing whitespace
            } else {
                return "";
            }
        },
        getSignedUrlPath(file) {
            if (file) {
                let config = {
                    headers: { Authorization: "Bearer " + localStorage.getItem("tkn") },
                    params: { file: file }
                };

                return HTTP.get("getsignedurlpath", config)
                    .then(response => response.data.file_path)
                    .catch(err => {
                        console.error("Error fetching signed URL:", err);
                        return null;
                    });
            }
            return Promise.resolve(null);
        },
    },
    computed: {
        // user_role: {
        //     get: function () {
        //         return this.$store.getters.roles;
        //     },
        //     set: function (value) {
        //         this.$store.commit('changeUserRole', value);
        //     }
        // },
        // pastTab: {
        //     get: function () {
        //         return this.$store.getters.past_tab;
        //     },
        //     set: function (value) {
        //         this.$store.commit('changePastTab', value);
        //     }
        // },
    }
};


// WEBPACK FOOTER //
// ./src/mixins/commonMixins.js